import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: ['Upperclass', 'Lower', 'Middle', 'Upper Middle'],
  datasets: [
    {
      label: '# of Votes',
      data: [17, 20, 40, 23],
      backgroundColor: [
        '#FFD600',
        '#A8B5FE',
        '#B68CFD',
        '#A0FF64',

        
      ],
      borderColor: [
        '#FFD600',
        '#A8B5FE',
        '#B68CFD',
        '#A0FF64',
       
      ],
      borderWidth: 1,
    },
  ],
};

export default()=> {
  return <> 
    <div className='col-md-6'>
      
        <label className='fw-bold' htmlFor="">
            Income level
        </label>
    <Doughnut data={data} />;
    </div>
        </>
}
